import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import AgentNavbar from "../../../component/AgentNavbar";
import { ChevronRight, Edit, Trash2 } from "react-feather";
import BookingReportMenu from "../AgentComp/BookingReportMenu";
import { baseurl } from "../../../component/Baseurl"; // Adjust base URL path

function AgentBookingReport() {
  const agentid = localStorage.getItem("agent_id"); // Get agent ID from local storage

  const [bookings, setBookings] = useState([]);
  const [filteredBookings, setFilteredBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [filters, setFilters] = useState({
    bookingId: "",
    travelDate: "",
    bookedOn: "",
    status: "",
  });

  // ✅ Fetch bookings for the logged-in agent
  const fetchBookings = async () => {
    try {
      const response = await axios.get(`${baseurl}/getAllHotelBookingsByAgentId/${agentid}`);
      console.log("API Response:", response.data);

      if (response.data.bookings) {
        setBookings(response.data.bookings);
        setFilteredBookings(response.data.bookings);
      } else {
        setBookings([]);
        setFilteredBookings([]);
      }
    } catch (error) {
      console.error("Error fetching hotel bookings:", error);
      setError("Failed to load bookings.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBookings();
  }, [agentid]);

  // ✅ Handle filter change
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // ✅ Apply filters
  useEffect(() => {
    const filtered = bookings.filter((booking) => {
      return (
        (filters.bookingId ? booking.resulttoken.includes(filters.bookingId) : true) &&
        (filters.travelDate ? booking.created_at.startsWith(filters.travelDate) : true) &&
        (filters.bookedOn ? booking.created_at.startsWith(filters.bookedOn) : true) &&
        (filters.status ? booking.status === filters.status : true)
      );
    });
    setFilteredBookings(filtered);
  }, [filters, bookings]);

  // ✅ Reset Filters
  const handleResetFilters = () => {
    setFilters({
      bookingId: "",
      travelDate: "",
      bookedOn: "",
      status: "",
    });
    setFilteredBookings(bookings);
  };

  return (
    <>
      <AgentNavbar />
      <div className="bgagent">
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center">
            <h1 className="text-start agenth1 pt-3 font4">
              <span>Booking Reports</span>
            </h1>
            <span className="text-muted">
              <span>Dashboard</span>
              <ChevronRight size={12} />
              <span>My Reports</span>
              <ChevronRight size={12} />
              <span>Booking Reports</span>
            </span>
          </div>

          <BookingReportMenu />

          {/* Show Loader while fetching data */}
          {loading && <span className="loader">Loading...</span>}
          {error && <p className="text-danger">{error}</p>}

          <div className="container-fluid">
            <div className="crdmain p-2 mb-2">
              {/* Filters Section */}
              <div className="row text-start g-3">
                <div className="col-md-3">
                  <label htmlFor="bookingId" className="form-label">Booking ID</label>
                  <input
                    type="text"
                    className="input1"
                    name="bookingId"
                    id="bookingId"
                    placeholder="Booking ID"
                    value={filters.bookingId}
                    onChange={handleFilterChange}
                  />
                </div>
                <div className="col-md-3">
                  <label htmlFor="travelDate" className="form-label">Travel Date</label>
                  <input
                    type="date"
                    className="input1"
                    name="travelDate"
                    id="travelDate"
                    value={filters.travelDate}
                    onChange={handleFilterChange}
                  />
                </div>
                <div className="col-md-3">
                  <label htmlFor="bookedOn" className="form-label">Booked On</label>
                  <input
                    type="date"
                    className="input1"
                    name="bookedOn"
                    id="bookedOn"
                    value={filters.bookedOn}
                    onChange={handleFilterChange}
                  />
                </div>
                {/* <div className="col-md-2">
                  <label htmlFor="status" className="form-label">Status</label>
                  <select
                    className="input1"
                    name="status"
                    id="status"
                    value={filters.status}
                    onChange={handleFilterChange}
                  >
                    <option value="">All Status</option>
                    <option value="active">Active</option>
                    <option value="cancelled">Cancelled</option>
                  </select>
                </div> */}
                <div className="col-md-2 text-end">
                  <button className="btn3 py-2" onClick={handleResetFilters}>
                    Reset Filters
                  </button>
                </div>
              </div>
            </div>

            {/* Table Section */}
            <div className="crdmain p-2">
              <div className="row g-1">
                <div className="col-md-12">
                  <div className="table-responsive">
                    <table className="table table-striped table-bordered">
                      <thead>
                        <tr>
                          <th scope="col">Sr No</th>
                          <th scope="col">Booking ID</th>
                          <th scope="col">Agent</th>
                          <th scope="col">Email</th>
                          <th scope="col">Phone</th>
                          <th scope="col">Travel Date</th>
                          <th scope="col">Booked On</th>
                          <th scope="col">Status</th>
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan="9" className="text-center">
                              <span className="loader"></span>
                            </td>
                          </tr>
                        ) : filteredBookings.length > 0 ? (
                          filteredBookings.map((booking, index) => (
                            <tr key={booking.id}>
                              <td>{index + 1}</td>
                              <td>{booking.resulttoken}</td>
                              <td>{booking.agent_name}</td>
                              <td>{booking.email}</td>
                              <td>{booking.phoneno}</td>
                              <td>{booking.created_at.split("T")[0]}</td>
                              <td>{booking.created_at.split("T")[0]}</td>
                              <td>
                                <span className={`badge 
                                  ${booking.status === "active" ? "bg-success" : "bg-danger"}
                                `}>
                                  {booking.status}
                                </span>
                              </td>
                              <td>
                                {/* <Link
                                  to={`/edit-booking/${booking.resulttoken}`}
                                  className="btn btn-primary btn-sm me-2"
                                >
                                  <Edit size={15} />
                                </Link> */}
                                {/* <button className="btn btn-danger btn-sm">
                                  <Trash2 size={15} />
                                </button> */}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="9" className="text-center">
                              No bookings found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AgentBookingReport;
